import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { Postpro, PostproReference } from '@state/postpro/postpro.interfaces';

@Injectable({
  providedIn: 'root'
})
export class PostproViewerService {

  constructCameraSet(postpro: Postpro[]) {
    const cameraSet = [...new Set(postpro.map(({ camera }) => camera))];
    cameraSet.sort((a, b) => a.localeCompare(b));
    return cameraSet;
  }
}

export const POSTPRO_ASPECT_RATIO = 1.777;

export function constructCameraSet<T extends { camera: string }>(postpro: T[]): string[] {
  const cameraSet = [...new Set(postpro.map(({ camera }) => camera))];
  cameraSet.sort((a, b) => a.localeCompare(b));
  return cameraSet;
}

export function constructPostproUrl(path: string, token: string): string {
  return `${environment.SERVER}api${path}?token=${token}`;
}

export function constructThumbnailUrl(url: string): string {
  if (url.includes('.mp4')) {
    return url.replace(/\.mp4/, '.png');
  } else {
   return url.replace(/\.png/, '_thumb.jpg');
  }
}

export function convertThumbnailToImage(url: string): string {
  return url.replace('_thumb.jpg', '.png');
}

export function convertToReference(
  postpro: Postpro,
  token: string,
  plotOverlayReferences: PostproReference[] = [],
  licReferences: PostproReference[] = [],
  ): PostproReference {
  const url = constructPostproUrl(postpro.path, token);
  const thumbnailUrl = constructThumbnailUrl(url);
  return {
    ...postpro,
    url,
    thumbnailUrl,
    plotOverlayReference: plotOverlayReferences.find(overlayReference => overlayReference.case.uuid === postpro.case.uuid),
    licOverlayReference: licReferences.find(licReference => {
      return licReference.camera === postpro.camera && licReference.case.uuid === postpro.case.uuid;
    }),
  };
}
